import { useState } from 'react'
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper'
import UiSaveButtons from '../../buttons/UiSaveButtons'
import { CalendarDirect } from '../../calendar/Calendar'
import { TimePickerDirect } from './TimePicker'
import FullPageWrapper from 'global/wrappers/FullPageWrapper'

export const DateTimePicker = ({ fullMode, startTime, startDate, teamsList, handleCancel, handleOk }) => {

  const [selectedDate, setSelectedDate] = useState()
  const [selectedTime, setSelectedTime] = useState()

  const handleDateSelect = (d) => setSelectedDate(d)
  const handleSelectedDate = (d) => setSelectedDate(d)
  const handleSetTime = (t) => setSelectedTime(t)

  const handle_ok = () => handleOk(selectedDate, selectedTime)

  const goodToGo = selectedDate && selectedTime ? true : false

  const wrapper = () => <Wrapper
    content={<div>
      <CalendarDirect handleSelectedDate={handleSelectedDate} handleDateSelect={handleDateSelect} />
      <TimePickerDirect handleCancel={handleCancel} initialValue={startTime} handleDone={handleSetTime} noFull={true} />
    </div>}
    footer={<UiSaveButtons save={{ oc: handle_ok, disabled: !goodToGo }} cancel={{ oc: handleCancel }} />}
    wrapperType={wrapperTypes.paddedFooter}
  ></Wrapper>

  const fpw = () => <FullPageWrapper
    topperCaption={'Date and Time Select'}
    content={wrapper()}
    handleCancel={handleCancel}
  />

  return fullMode ? fpw() : wrapper()
}
